<div
  style="display: inline-block"
  class="doc-button-wrapper"
  *ngIf="_type === 'image'"
>
  <button mat-button *ngIf="label" (click)="takePhoto()">
    <mat-icon>photo_camera</mat-icon>
    <span>{{ label }}</span>
  </button>
</div>

<div
  style="display: inline-block"
  class="doc-button-wrapper"
  *ngIf="_type === 'video'"
>
  <button mat-button *ngIf="label" (click)="takeVideo()">
    <mat-icon>videocam</mat-icon>
    <span>{{ label }}</span>
  </button>
</div>
